// kfe-dialog-comp-meter.js — Dialogue Comprehension meter (type 17).
//
// iOS REFERENCE: KFEDialoCompreMeterVC — ONE 0–100% slider ("How much of the
// dialogue could you understand?"), two pass thresholds, and a feedback screen
// branched pass / fail-preceding / fail-following with the playcount delta
// interpolated. The affected-item direction is read from data (unlike
// Listening, which hardcodes preceding). answer2 is never used here.
//
// Brief 055: collects answer1 (slider), then shows the iOS feedback screen via
// the shared base, finalizing with kfe:meter-complete { answer1, answer2:null }.

import { html } from "../core/html.js";
import { t } from "../core/i18n.js";
import { KFEMeterBase, METER_MODAL_STYLES } from "./kfe-meter-base.js";

export class KFEDialogCompMeter extends KFEMeterBase {
  static styles = METER_MODAL_STYLES;

  constructor() {
    super();
    /** @type {"input"|"feedback"} */ this._phase = "input";
    // iOS UISlider defaults to its minimumValue (0); mirror that start point.
    this._answer1 = 0;
  }

  _confirm() {
    if (this._phase !== "input") return;
    this._phase = "feedback";
    this._scheduleRender();
  }

  render() {
    const card = document.createElement("div");
    card.className = "card";

    if (this._phase === "feedback") {
      card.appendChild(this._feedbackNode("dialogComp", this._answer1, null));
      return html`${card}`;
    }

    const h2 = document.createElement("h2");
    h2.textContent = this._title();
    card.appendChild(h2);

    card.appendChild(this._sliderBlock(
      t("meter.dialogComp.prompt"),
      t("meter.dialogComp.sliderHint"),
      this._answer1,
      (v) => { this._answer1 = v; },
    ));

    const actions = document.createElement("div");
    actions.className = "actions";
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "confirm";
    btn.textContent = t("meter.confirm");
    btn.addEventListener("click", () => this._confirm());
    actions.appendChild(btn);
    card.appendChild(actions);

    return html`${card}`;
  }
}
